import React from 'react'

export const UpcomingMatches = () => {
  return (
    <div>Upcoming matches</div>
  )
}
